import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { Player } from 'src/models/player.model';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { MyScores } from 'src/models/myscores.model';
import { UserService } from 'src/services/user.service';
import { map } from 'rxjs/operators';
import { ProfileService } from '../profile/profile.service';

@Component({
  selector: 'player',
  templateUrl: './player.component.html',
  styleUrls: ['player.component.scss']
})
export class PlayerComponent implements OnInit {
  public scores: MyScores = new MyScores();
  public isTiebreakTourney: boolean = false
  public playerId!: string;
  public avatar?: string;

  constructor(private authorizeService: AuthorizeService,
    private http: HttpClient, private router: Router, private route: ActivatedRoute,
    private profileSvc: ProfileService) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.playerId = params['playerId'];
      this.http.get<any>(`/api/playerapi/${this.playerId}`)
        .subscribe(
          (resp) => {
            this.scores = new MyScores(resp);
            this.isTiebreakTourney = this.scores.results[0].ladderType == 'Tiebreak';
          }
        )
      this.profileSvc.getAvatar(this.playerId).subscribe(
        (resp) => this.avatar = resp.base64img,
        (err) => console.log('no avatar found')
      );

    });
  }
}
